import { styled } from '@mui/material/styles';

import { IconButton } from '@mui/material';

const CustomIconButton = styled(IconButton, {
    shouldForwardProp: (prop) => !['isActive'].includes(prop)
})(({ theme, isActive }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    fontWeight: 'bold',
    border: 0,
    borderRadius: 8,
    cursor: 'pointer',
    color: isActive
        ? theme.palette.primary.contrastText
        : theme.palette.secondary.contrastText,
    backgroundColor: isActive
        ? theme.palette.primary.main
        : theme.palette.secondary.main,
    transition: 'color 0.2s ease',
    '&:hover': {
        backgroundColor: isActive
            ? theme.palette.primary.hover
            : theme.palette.secondary.hover,
    },
    '&.MuiIconButton-sizeLarge': {
        fontSize: 16,
        padding: theme.spacing(1.5),
        paddingRight: theme.spacing(2),
    },
}));

export default CustomIconButton;
